import { useState, useEffect, useCallback } from 'react';
import { API_BASE_URL } from '../utils/api';

// Loads a captcha from Email_service; the answer is checked on the server when the form is submitted.
export const useCaptcha = () => {
  const [captchaCode, setCaptchaCode] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [enterCaptchaCode, setEnterCaptchaCode] = useState("");

  const refreshCaptcha = useCallback(async () => {
    setEnterCaptchaCode("");
    try {
      const response = await fetch(`${API_BASE_URL}/captcha`);
      if (!response.ok) throw new Error("Captcha request failed");
      const data = await response.json();
      setCaptchaCode(data.image);
      setCaptchaToken(data.token);
    } catch (err) {
      setCaptchaCode("");
      setCaptchaToken("");
    }
  }, []);

  useEffect(() => {
    refreshCaptcha();
  }, [refreshCaptcha]);

  return { captchaCode, captchaToken, enterCaptchaCode, setEnterCaptchaCode, refreshCaptcha };
};
